import { __spreadArrays } from "tslib";
import { COMPONENT_TYPE } from '../dependents';
/**
 * 判断text是否可用, title description
 *
 * @param source
 */
export function isTextUsable(source) {
    if (!source)
        return false;
    if (source.visible === true && typeof source.text === 'string' && source.text.trim())
        return true;
    return false;
}
/**
 * 为字符串添加换行符
 * @param source - 字符串数组 ['a', 'b', 'c']
 * @param breaks - 要添加换行的index
 *
 * @example
 * ```js
 * breakText(['a','b','c'], [1])
 *
 * // a\nbc
 * ```
 */
export function breakText(source, breaks) {
    var result = __spreadArrays(source);
    breaks.forEach(function (pos, index) {
        result.splice(pos + index, 0, '\n');
    });
    return result.join('');
}
/**
 * 获取 View 中所有的 Axis 组件
 */
export function getAxisComponents(view) {
    return view
        .getComponents()
        .filter(function (co) { return co.type === COMPONENT_TYPE.AXIS; })
        .map(function (co) { return co.component; });
}
export function getLegendComponents(view) {
    return view
        .getComponents()
        .filter(function (co) { return co.type === COMPONENT_TYPE.LEGEND; })
        .map(function (co) { return co.component; });
}
export function getAxisShapes(view) {
    var axisShape = view.backgroundGroup.findAll(function (el) {
        if (el.get('name')) {
            var name_1 = el.get('name').split('-');
            return name_1[0] === 'axis';
        }
    });
    return axisShape;
}
export function getLegendShapes(view) {
    var axisShape = view.foregroundGroup.findAll(function (el) {
        if (el.get('name')) {
            return el.get('name') === 'legend-item-group';
        }
    });
    return axisShape;
}
export function sortedLastIndex(arr, val) {
    var i = arr.length;
    while (i > 0) {
        if (val >= arr[i - 1]) {
            break;
        }
        i -= 1;
    }
    return i;
}
/* 检测两个label包围盒是否重叠 */
export function isBBoxIntersect(bboxA, bboxB) {
    if (bboxA.maxY < bboxB.minY || bboxB.maxY < bboxA.minY) {
        return false;
    }
    if (bboxA.maxX < bboxB.minX || bboxB.maxX < bboxA.minX) {
        return false;
    }
    return true;
}
/**
 * 判断是否移动端环境
 */
export function isMobile() {
    return !!navigator.userAgent.match(/(Mobile)|(Android)|(WebOS)|(iPhone)|(iPad)/);
}
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/util/common.js
// module id = null
// module chunks = 